export function getCopyrightYear(date = new Date()) {
  return date.getFullYear();
}
